import { configureStore } from "@reduxjs/toolkit";

import studyDataReducer from "./features/studyDataSlice";
import consumerFilterReducer from "./features/consumerFilterSlice";
import dataMappingReducer from "./features/dataMappingSlice";
import userReducer from "./features/userSlice";
import analysisResultsReducer from "./features/analysisResultsSlice";
import productsInfoReducer from "./features/productsInfoSlice";
import correlationReducer from "./features/correlationSlice";
import driverAnalysisReducer from "./features/driverAnalysisSlice";
import claimsAnalysisReducer from "./features/claimsAnalysisSlice";
import claimsMappingReducer from "./features/claimsMappingSlice";
import analysisKpiReducer from "./features/analysisKpiSlice";
import settingsReducer from "./features/settingsSlice";
import respondentDashboardReducer from "./features/respondentDashboardSlice";
import analysisTypeSelectionReducer from "./features/analysisTypeSelectionSlice";
import notificationReducer from "./features/notificationSlice";
import tTestStoreReducer from "./features/ttestSlice";
import cohensDReducer from "./features/cohensDSlice";
import dataControlReducer from "./features/dataControlSlice";
import textThemeReducer from "./features/textThemeSlice";
import matchNetStore from "./features/matchNetSlice";
import activeTabStore from "./features/activeTabSlice";

export const store = configureStore({
    reducer: {
        studyDataStore: studyDataReducer,
        consumerFilterStore: consumerFilterReducer,
        dataMappingStore: dataMappingReducer,
        userStore: userReducer,
        analysisResultsStore: analysisResultsReducer,
        productsInfoStore: productsInfoReducer,
        correlationStore: correlationReducer,
        driverAnalysisStore: driverAnalysisReducer,
        claimsAnalysisStore: claimsAnalysisReducer,
        matchNetStore: matchNetStore,
        claimsMappingStore: claimsMappingReducer,
        analysisKpiStore: analysisKpiReducer,
        settingsStore: settingsReducer,
        respondentDashboardStore: respondentDashboardReducer,
        analysisTypeSelectionStore: analysisTypeSelectionReducer,
        notificationStore: notificationReducer,
        tTestStore: tTestStoreReducer,
        cohensDStore: cohensDReducer,
        dataControlStore: dataControlReducer,
        textThemeStore: textThemeReducer,
        activeTabStore: activeTabStore,
    },
});
